import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Stack,
  Typography
} from "@mui/material";
import { useSelector } from "react-redux";
import { getProfile } from "../core/service/users.service";
import { getResearchExtensionByStdId } from "../core/service/researchExtension.service";
import moment from "moment";

// components
import Page from "../components/Page";
import TableActivityExtension from "../components/_dashboard/app/TableActivityExtension";
import { useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------
const ROLE_ADMIN = "admin";
const ROLE_MENTOR = "mentor";
const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";
const ROLE_POSTDOC = "post_doc";

const hrefRequestExtensionPostdoc = "/request-extension/post_doc";
const hrefRequestExtensionPhd3y = "/request-extension/phd_3y";
const hrefRequestExtensionPhd5y = "/request-extension/phd_5y";

export default function ExtensionSTD() {
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const [user, setUser] = useState({});
  const [extension, setExtension] = useState(0);

  useEffect(() => {
    const getUserProfile = async (id) => {
      const data = await getProfile(id);
      const extensionByStdId = await getResearchExtensionByStdId(id);
      const extension = extensionByStdId?.filter(
        (e) => e?.mentor_approve === 1
      ).length;

      setUser(data);
      setExtension(extension);
    };

    getUserProfile(id);
  }, []);

  const navigate = useNavigate();
  const pathNext = () =>{
    return navigate(
      role === ROLE_POSTDOC
                  ? hrefRequestExtensionPostdoc
                  : role === ROLE_PHD_3Y
                  ? hrefRequestExtensionPhd3y
                  : role === ROLE_PHD_5Y && hrefRequestExtensionPhd5y
      , { replace: true });
  }

  return (
    <Page title="ExtensionSTD">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">Extension</Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={12}>
            <Card>
              <Container>
                <Box sx={{ p: 3, pb: 1 }} dir="ltr">
                  <Stack direction="row" spacing={2}>
                    <Typography variant="subtitle2">Received date :</Typography>
                    <Typography>
                      {role === ROLE_POSTDOC
                        ? moment(
                            user?.postdoctoral_information?.start_reciving
                          ).format("DD/MM/YY")
                        : moment(
                            user?.student_phd_information?.start_reciving
                          ).format("DD/MM/YY")}
                    </Typography>
                    <Typography variant="subtitle2">to</Typography>
                    <Typography>
                      {role === ROLE_POSTDOC
                        ? moment(
                            user?.postdoctoral_information?.contract_end
                          ).format("DD/MM/YY")
                        : moment(
                            user?.student_phd_information?.contract_end
                          ).format("DD/MM/YY")}
                    </Typography>
                  </Stack>

                  <Stack direction="row" spacing={2} sx={{ paddingTop: 3 }}>
                    <Typography variant="subtitle2">
                      Approval of the extension:
                    </Typography>
                    <Typography>{extension}</Typography>
                    <Typography variant="subtitle2">time(s)</Typography>
                    <Typography sx={{ color: "red" }}>
                      {`(${3 - extension === 0 ? 0 : 3 - extension} time left)`}
                    </Typography>
                  </Stack>
                </Box>
              </Container>
            </Card>
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <TableActivityExtension />
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <Button
              variant="contained"
              size="large"
              // href={
              //   role === ROLE_POSTDOC
              //     ? hrefRequestExtensionPostdoc
              //     : role === ROLE_PHD_3Y
              //     ? hrefRequestExtensionPhd3y
              //     : role === ROLE_PHD_5Y && hrefRequestExtensionPhd5y
              // }
              onClick={()=>pathNext()}
            >
              Request Extension
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
